<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <!-- sourceType -->

  <mat-form-field>
    <app-easy-select
      formControlName="sourceType"
      [label]="TITLE + 'SOURCE_TYPE' | translate"
      [translatePrefixForSelected]="'PRODUCTS.SOURCE_TYPE.'"
      [labelAttribute]="'name'"
      [valueAttribute]="'value'"
      [hasEmptyOption]="false"
      [options]="sourceType | toSelectOption: 'PRODUCTS.SOURCE_TYPE.'"
    >
    </app-easy-select>
  </mat-form-field>

  <!-- flavored -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="flavored"
      [label]="TITLE + 'IS_FLAVORED' | translate"
      (ngModelChange)="onFlavoredChange($event)"
    ></app-easy-checkbox>
  </mat-form-field>

  <div class="in-two-columns">
    <!-- flavorTypes -->

    <mat-form-field *ngIf="getCtrl('flavorTypes')">
      <app-easy-select
        formControlName="flavorTypes"
        [label]="TITLE + 'FLAVOR_TYPES' | translate"
        [translatePrefixForSelected]="'PRODUCTS.FLAVOR_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="flavorType | toSelectOption: 'PRODUCTS.FLAVOR_TYPE.':true"
        [multiple]="true"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- acidityLevel -->

    <mat-form-field>
      <app-easy-select
        formControlName="acidityLevel"
        [label]="TITLE + 'ACIDITY_LEVEL' | translate"
        [translatePrefixForSelected]="'PRODUCTS.ACIDITY_LEVEL.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="acidityLevel | toSelectOption: 'PRODUCTS.ACIDITY_LEVEL.'"
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <!-- sugar fields -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsAddedSugar"
      [label]="TITLE + 'CONTAINS_ADDED_SUGAR' | translate"
    ></app-easy-checkbox>
  </mat-form-field>

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsAddedSweetener"
      [label]="TITLE + 'CONTAINS_ADDED_SWEETENER' | translate"
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- !sugar fields -->
</fieldset>
